import {
  DefaultFetchError,
  FetchGet,
  FetchGetId,
  PagingDataResponse,
  PagingParams,
  useFetchGet,
  useFetchGetId,
} from "../fetch";

export interface Exercise {
  id: string;
  name: string;
  middah: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface Middah {
  id: string;
  name: string;
  exercises: Exercise[];
  exercisesSize: number;
  createdAt: string;
  updatedAt: string;
}

export interface MiddahTableRow extends Middah {
  key: string;
}

export interface MiddahTableData {
  data: MiddahTableRow[];
  total: number;
}

export interface MiddahGetParams
  extends
    PagingParams,
    Partial<Omit<Middah, "id" | "exercises" | "exercisesSize">> {
  orderByColumn?: keyof Omit<Middah, "id" | "exercises" | "exercisesSize">;
}

export const useMiddahsGet = <DD = PagingDataResponse<Middah>>(
  decorateData?: (data: PagingDataResponse<Middah>) => DD,
): FetchGet<
  PagingDataResponse<Middah>,
  MiddahGetParams,
  DefaultFetchError,
  DD
> =>
  useFetchGet("middahs", {
    autoStart: false,
    startStateLoading: false,
    decorateData,
  });

export const useMiddahTableGet = () =>
  useMiddahsGet<MiddahTableData>(
    ({ data, meta }: PagingDataResponse<Middah>): MiddahTableData => ({
      data: data.map((item) => ({
        key: item.id,
        ...item,
      })),
      total: meta.itemCount,
    }),
  );

export const useMiddahGetById = <DD = Middah>(
  id?: string,
  decorateData?: (data: Middah) => DD,
): FetchGetId<Middah, DefaultFetchError, unknown, DD> =>
  useFetchGetId("middahs", id, {
    autoStart: !!id,
    decorateData,
  });
